/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeLatest } from 'redux-saga/effects'
import { getCrewSelector } from '../selectors'
import { setCrewList } from '../store/crew.actions'
import { CrewConstants } from '../store/crew.constants'
import { ICrewState } from '../store/crew.types'
import { getUserSelector } from '../../user/selectors'
import { IUserState } from '../../user/store/user.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setCrewMemberName() {
  const crew: ICrewState = yield select(getCrewSelector)
  const { crewMember, crewList, userId, crewListData } = crew
  if (crewList.length === 1 && !userId) {
    const user: IUserState = yield select(getUserSelector)
    const { userId } = user
    const crewOption = crewListData.filter((crewOption) => crewOption.id === +userId)
    crewList[0].userId = crewOption ? crewOption[0] : null
    yield put(setCrewList(crewList))
  } else {
    const selectedCrew = crewList.filter((cl) => cl.key === crewMember?.key)
    if (selectedCrew && selectedCrew.length) {
      selectedCrew[0].userId = userId
    }
    yield put(setCrewList(crewList))
  }
}

export function* setNameSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, CrewConstants.SET_NAME], setCrewMemberName)
}
